import { useAuth0 } from '@auth0/auth0-react';
import { useContext, useRef } from 'react';
import { useEffect } from 'react';
import { store } from 'components/Store';
import normalize from 'components/Dashboard/utilities/normalizeString';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import { useLocation } from 'react-router';

const useGetContactsTags = (props) => {
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { team } = state ?? {};

  const { notCallInitially = false } = props ?? {};
  const { isAuthenticated } = useAuth0();
  const location = useLocation();

  let hash = window.location.hash;
  let hashParts = hash !== '' ? hash.split('#')[1].split('~') : [];

  const modifyContactsTags = (results) => {
    if (location.pathname.includes('/people/directory')) {
      //GET FILTERS FROM HASH
      let resultToStore = results;
      hashParts.forEach((hash) => {
        resultToStore.forEach((item) => {
          if (hash === 'tag-is-not-' + normalize(item.value)) {
            item.selected = 'exclude';
          } else if (hash === normalize(item.value)) {
            item.selected = true;
          }
        });
      });
      return resultToStore;
    } else {
      return results;
    }
  };

  const { generalApiCall } = useGeneralApiCall();
  const callTags = useRef(null);

  callTags.current = async (source) => {
    const pathname = `/api/autocomplete/crm-contact-tag`;
    const method = 'get';
    const results = await generalApiCall({
      method,
      pathname,
      needsAuthentication: true,
      requestSource: source,
      notShowErrorMessage: true,
    });
    if (results) {
      dispatch({
        type: 'MODIFY_SECTION',
        parameter: 'contactsTags',
        value: modifyContactsTags(results),
      });
    }
  };

  useEffect(() => {
    const source = new AbortController();

    try {
      if (!notCallInitially) {
        const asyncFn = async () => {
          if (isAuthenticated) {
            callTags.current(source);
          }
        };
        asyncFn();
      }
    } catch (e) {}

    return () => {
      source.abort('Contact tag canceled by the user.');
    };
  }, [isAuthenticated, team]);

  return { upadateContactTags: callTags.current };
};

export default useGetContactsTags;
